var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app","color":"grey lighten-5"}},[_c('NavBar'),_c('v-main',{staticClass:"ma-5"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }